import React from "react";
import ChatWindow from "./components/ChatWindow/ChatWindow";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ChatWindow />
    </div>
  );
}

export default App;
